// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
//import './less/app.less';
import 'babel-polyfill'
import Vue from 'vue';
import App from './App.vue';
import $ from 'jquery';
import 'bootstrap';
import utils from './helpers/utils';
import {SiteConfig} from './config';
window['$'] = $;
window['utils'] = utils;
window['SiteConfig'] = SiteConfig;
Vue.config.productionTip = false;

import './less/app.less';
import './components';
import './plugins';
import router from './router';
import store from './store';
import * as filters from './filters';
import mixins from './mixins';
import './vdirectives';
//
// // register global utility filters.
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key]);
});
// // register global mixins.
Vue.mixin(mixins);
import Account from './services/AccountService';
Account.loadStoreCache();


var app = new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: {
        App
    }
});
window['bus'] = new Vue();
window['app'] = app;



// WEBPACK FOOTER //
// ./src/main.ts